export default __webpack_public_path__ + "static/library-icon-895aaf1cab573c819deff2fe149d7cad.svg";